<template>
    <div id="filter_advanced">
        <div class="ui form" @keypress.enter="$parent.$parent.customers_filter()">
            <div class="three fields">
                <div class="field">
                    <label>{{ $t('models.attributes.customers.username') }}</label>
                    <input type="text"
                        v-model="filter.columns.username"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.customers.company_name') }}</label>
                    <input type="text"
                        v-model="filter.columns.company_name"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.customers.email') }}</label>
                    <input type="text"
                        v-model="filter.columns.email"
                    >
                </div>
            </div>
            <div class="four fields">
                <div class="field">
                    <label>{{ $t('models.attributes.customers.phone') }}</label>
                    <input type="text"
                        v-model="filter.columns.phone"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.customers.fax') }}</label>
                    <input type="text"
                        v-model="filter.columns.fax"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.customers.is_banned') }}</label>
                    <div class="ui checkbox" v-checkbox>
                        <input type="checkbox" v-model="filter.columns.is_banned">
                        <label>{{ $t('ui.general.yes') }}</label>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="ui icon blue button right floated"
            @click="$parent.$parent.customers_filter()">
            <i class="search icon"></i>
            {{ $t('ui.general.search') }}
        </div>
        <div class="clear">

        </div>
    </div>
</template>

<script>

export default {
    name: "CustomersFilterAdvanced",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.customers_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>

<style scoped lang="scss">

</style>
